import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const TrashIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.002 3.66663L12.5888 10.35C12.4832 12.0576 12.4305 12.9114 12.0025 13.5252C11.7908 13.8287 11.5184 14.0848 11.2024 14.2773C10.5634 14.6666 9.70795 14.6666 7.99709 14.6666C6.28403 14.6666 5.42749 14.6666 4.78799 14.2766C4.47182 14.0838 4.19929 13.8272 3.98774 13.5232C3.55987 12.9084 3.50825 12.0534 3.40503 10.3434L3.00195 3.66663"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.00195 3.66671H14.002M10.7058 3.66671L10.2507 2.72786C9.94835 2.10421 9.79715 1.79239 9.53642 1.59791C9.47862 1.55477 9.41735 1.5164 9.35329 1.48317C9.06455 1.33337 8.71802 1.33337 8.02495 1.33337C7.31449 1.33337 6.95929 1.33337 6.66574 1.48945C6.60069 1.52405 6.53861 1.56397 6.48015 1.60882C6.21638 1.81117 6.06904 2.13441 5.77436 2.78088L5.37057 3.66671"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6.33527 11V7"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.66864 11V7"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export const TrashIconMedium: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.5 16.5V10.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.5 16.5V10.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
